import { MenuItem, Select } from "@mui/material";
import moment from "moment-timezone";
import { getMyZone } from "../../constants/getTimeDate";
import DateAndTimePicker from "../DateAndTimePicker";
import React, { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import { IMAGE_SUB_TYPE, IMAGE_TYPE } from "../../constants/ImageConstant";
import LocationAndExpcept from "../../constants/LocationAndExpcept";
import PropTypes from "prop-types";
import { constants } from "../../constants/constants";
import {
  createBanner,
  deleteBannerData,
  getBannerDataLocation,
  updateBannerData,
  cleanupBannerImages,
} from "../../utils/ApiCalls/Banner";
import { uploadFile,uploadFileMobile} from "../../utils/ApiCalls/Document";
import { getAllLocations } from "../../utils/ApiCalls/Locations";
import { addlog } from "../../utils/ApiCalls/Logs";
import { checkFields } from "../../utils/Validation/checkFields";
import UploadFileImageBanner2 from "./uploadFileImageBanner copy";
import AltTextInput, { pickAltText } from "../AltTextInput/AltTextInput";

const BANNER_ALT_FIELDS = [
  "image_alt",
  "simplified_chinese_image_alt",
  "traditional_chinese_image_alt",
  "bahasa_image_alt",
  "english_mobile_image_alt",
  "simplified_mobile_chinese_image_alt",
  "traditional_mobile_chinese_image_alt",
  "bahasa_mobile_image_alt",
];

const BannerInputs = ({ banner }) => {
  const [englishTitle, setEnglishTitle] = useState(banner?.englishTitle || "");
  const [description, setDescription] = useState(banner?.description || "");
  const [simplifiedChineseTitle, setSimplifiedChineseTitle] = useState(
    banner?.simplifiedChineseTitle || ""
  );
  const [currentLocation, setCurrentLocation] = useState([]);
  const [traditionalChineseTitle, setTraditionalChineseTitle] = useState(
    banner?.traditionalChineseTitle || ""
  );

  const [isActive, setIsActive] = useState(true);
  const [isDateEdit, setIsDateEdit] = useState(false);
  const originalValidDates = useRef({ valid_from: "", valid_to: "" });
  const [selectedFile, setSelectedFile] = useState(null);
  const [title, setTitle] = useState(banner?.title || "");
  const [displayLocation, setDisplayLocation] = useState([]);

  const [locationOption, setLocationOption] = useState([]);
  const [mediaOption, setMediaOption] = useState("image");
  const [{ userDetails }, dispatch] = useDataLayerValue();
  const [valid_from, setValidFrom] = useState();
  const [bannerUrlData, setBannerUrlData] = useState({});
  const [valid_to, setValidTo] = useState();
  const [traditional_chinese_image, setTraditional_chinese_image] =
    useState(null);
  const [simplified_chinese_image, setSimplified_chinese_image] =
    useState(null);
  const [simplified_mobile_chinese_image, setSimplified_mobile_chinese_image] =
    useState(null);
    const [traditional_mobile_chinese_image, setTraditional_mobile_chinese_image] =
    useState(null);
  const [english_mobile_image, setEnglish_mobile_image] =
    useState(null);
  const [bahasa_title, setBahasa_title] = useState("");
  const [bahasa_image, setBahasa_image] = useState(null);
  const [bahasa_mobile_image, setBahasa_mobile_image] = useState(null);
  const [altText, setAltText] = useState(pickAltText(banner, BANNER_ALT_FIELDS));

  const [error, setError] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    if (!banner?.id) setIsDateEdit(true);
    if (banner) {
      if (
        banner.image ||
        banner.simplified_chinese_image ||
        banner.traditional_chinese_image ||
        banner.bahasa_image
      ) {
        getLocationData();
      }
      setTitle(banner?.title);
      setDescription(banner?.description);
      setSimplifiedChineseTitle(banner?.simplified_chinese_title);
      setTraditionalChineseTitle(banner?.traditional_chinese_title);

      setEnglishTitle(banner?.english_title);
      setBahasa_title(banner?.bahasa_title || "");
      setAltText(pickAltText(banner, BANNER_ALT_FIELDS));
      setMediaOption(banner?.content_type || "image");
      if (banner.location_id) setDisplayLocation([banner.location_id]);
      if (banner?.is_active !== undefined) setIsActive(banner.is_active === 1);

    }
  }, [banner]);

  useEffect(() => {
    if (banner && locationOption.length > 0) {
      const tz = locationOption.find(l => l.id == banner.location_id)?.timezone || "Asia/Kuala_Lumpur";
      const initialValidFrom = banner?.valid_from ? moment.utc(banner.valid_from).tz(tz).format("YYYY-MM-DDTHH:mm:ss") : "";
      const initialValidTo = banner?.valid_to ? moment.utc(banner.valid_to).tz(tz).format("YYYY-MM-DDTHH:mm:ss") : "";
      setValidFrom(initialValidFrom);
      setValidTo(initialValidTo);
      originalValidDates.current = { valid_from: initialValidFrom, valid_to: initialValidTo };
      if (banner?.id) setIsDateEdit(false);
    }
  }, [banner, locationOption]);

  const getLocationData = async () => {
    const bannerImage =
      banner.image ||
      banner.simplified_chinese_image ||
      banner.traditional_chinese_image ||
      banner.bahasa_image;
    let data = await getBannerDataLocation({ image: bannerImage });

    if (data.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: data.error,
      });
    } else {
      setCurrentLocation(data);
      let val = {};
      data.map((item) => {
        val[item.location_id] = item.url;
      });
      setBannerUrlData(val);
      setDisplayLocation(data?.map((item) => item.location_id) || []);
    }
  };
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link"], //"image"
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];

  const handleEnglishTitleChange = (content) => {
    setEnglishTitle(content);
  };

  const handleSimplifiedChineseTitleChange = (content) => {
    setSimplifiedChineseTitle(content);
  };

  const handleTraditionalChineseTitleChange = (content) => {
    setTraditionalChineseTitle(content);
  };

  const handleBahasaTitleChange = (content) => {
    setBahasa_title(content);
  };

  const handleCheckboxChange = () => {
    try {
      if (new Date(valid_to) < new Date()) {
        throw new Error(`Banner is expired`);
      }
      setIsActive(!isActive);
    } catch (e) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: e.message,
      });
    }
  };

  const handleDisplayLocationChange = (selectedOptions) => {
    setDisplayLocation(selectedOptions);
  };
  useEffect(() => {
    getOptionLocation();
  }, []);

  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getAllLocations();

    if (data.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: data.error,
      });
    } else {
      setLocationOption(data?.data || []);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  const addBanner = async (e) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    e.preventDefault();
    let dataValues = {
      title,
      content_type: mediaOption,
      description,
      order_by: 1,
      is_active: isActive ? 1 : 0,
      english_title: englishTitle,
      simplified_chinese_title: simplifiedChineseTitle,
      traditional_chinese_title: traditionalChineseTitle,
      bahasa_title: bahasa_title,
      valid_from: valid_from,
      valid_to: valid_to,
      isDateEdit,
      ...altText,
    };

    try {
      if (selectedFile) {
        if (typeof selectedFile === "string") {
          dataValues.image = selectedFile.replace(constants.MEDIAURL + "/", "");
        } else {
          let imageType = {
            type: IMAGE_TYPE.BANNER_IMG,
            subType: IMAGE_SUB_TYPE.ENGLISH_IMG,
          };
          let image = await uploadFile(selectedFile, imageType, undefined, typeof banner?.image === 'string' ? banner.image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "") : null);
          if (image?.error) throw new Error(image.error);
          dataValues.image = image?.url;
        }
      } else {
        dataValues.image = "";
      }
      if (simplified_chinese_image) {
        if (typeof simplified_chinese_image === "string") {
          dataValues.simplified_chinese_image =
            simplified_chinese_image.replace(constants.MEDIAURL + "/", "");
        } else {
          let imageType = {
            type: IMAGE_TYPE.BANNER_IMG,
            subType: IMAGE_SUB_TYPE.SIMPLIFIED_CHINESE_IMG,
          };

          let image2 = await uploadFile(simplified_chinese_image, imageType, undefined, typeof banner?.simplified_chinese_image === 'string' ? banner.simplified_chinese_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "") : null);
          if (image2?.error) throw new Error(image2.error);
          dataValues.simplified_chinese_image = image2?.url;
        }
      } else {
        dataValues.simplified_chinese_image = "";
      }
      if (traditional_chinese_image) {
        if (typeof traditional_chinese_image === "string") {
          dataValues.traditional_chinese_image =
            traditional_chinese_image.replace(constants.MEDIAURL + "/", "");
        } else {
          let imageType = {
            type: IMAGE_TYPE.BANNER_IMG,
            subType: IMAGE_SUB_TYPE.TRADITIONAL_CHINESE_IMG,
          };

          let image3 = await uploadFile(traditional_chinese_image, imageType, undefined, typeof banner?.traditional_chinese_image === 'string' ? banner.traditional_chinese_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "") : null);
          if (image3?.error) throw new Error(image3.error);
          dataValues.traditional_chinese_image = image3?.url;
        }
      } else {
        dataValues.traditional_chinese_image = "";
      }
    //  for mobile
      if (english_mobile_image) {
      if (typeof english_mobile_image === "string") {
        dataValues.english_mobile_image = english_mobile_image.replace(constants.MEDIAURL + "/", "");
      } else {
        let imageType = { type: IMAGE_TYPE.BANNER_MOBILE_IMG, subType: IMAGE_SUB_TYPE.ENGLISH_MOBILE_IMG };
        let image4 = await uploadFileMobile(english_mobile_image, imageType, undefined, undefined, typeof banner?.english_mobile_image === 'string' ? banner.english_mobile_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "") : null);
        if (image4?.e) throw new Error(image4.e?.message);
        dataValues.english_mobile_image = image4?.url;
      }
    } else {
      dataValues.english_mobile_image = "";
    }

     if (simplified_mobile_chinese_image) {
      if (typeof simplified_mobile_chinese_image === "string") {
        dataValues.simplified_mobile_chinese_image =
          simplified_mobile_chinese_image.replace(constants.MEDIAURL + "/", "");
      } else {
        let imageType = { type: IMAGE_TYPE.BANNER_MOBILE_IMG, subType: IMAGE_SUB_TYPE.SIMPLIFIED_CHINESE_MOBILE_IMG };
        let image5 = await uploadFileMobile(simplified_mobile_chinese_image, imageType, undefined, undefined, typeof banner?.simplified_mobile_chinese_image === 'string' ? banner.simplified_mobile_chinese_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "") : null);
        if (image5?.e) throw new Error(image5.e?.message);
        dataValues.simplified_mobile_chinese_image = image5?.url;
      }
    } else {
      dataValues.simplified_mobile_chinese_image = "";
    }
        if (traditional_mobile_chinese_image) {
          if (typeof traditional_mobile_chinese_image === "string") {
            dataValues.traditional_mobile_chinese_image =
              traditional_mobile_chinese_image.replace(constants.MEDIAURL + "/", "");
          } else {
            let imageType = { type: IMAGE_TYPE.BANNER_MOBILE_IMG, subType: IMAGE_SUB_TYPE.TRADITIONAL_CHINESE_MOBILE_IMG };
            let image6 = await uploadFileMobile(traditional_mobile_chinese_image, imageType, undefined, undefined, typeof banner?.traditional_mobile_chinese_image === 'string' ? banner.traditional_mobile_chinese_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "") : null);
            if (image6?.e) throw new Error(image6.e?.message);
            dataValues.traditional_mobile_chinese_image = image6?.url;
          }
        } else {
          dataValues.traditional_mobile_chinese_image = "";
        }

      if (bahasa_image) {
        if (typeof bahasa_image === "string") {
          dataValues.bahasa_image = bahasa_image.replace(constants.MEDIAURL + "/", "");
        } else {
          let imageType = { type: IMAGE_TYPE.BANNER_IMG, subType: IMAGE_SUB_TYPE.BAHASA_IMG };
          let image7 = await uploadFile(bahasa_image, imageType, undefined, typeof banner?.bahasa_image === 'string' ? banner.bahasa_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "") : null);
          if (image7?.error) throw new Error(image7.error);
          dataValues.bahasa_image = image7?.url;
        }
      } else {
        dataValues.bahasa_image = "";
      }

      if (bahasa_mobile_image) {
        if (typeof bahasa_mobile_image === "string") {
          dataValues.bahasa_mobile_image = bahasa_mobile_image.replace(constants.MEDIAURL + "/", "");
        } else {
          let imageType = { type: IMAGE_TYPE.BANNER_MOBILE_IMG, subType: IMAGE_SUB_TYPE.BAHASA_MOBILE_IMG };
          let image8 = await uploadFileMobile(bahasa_mobile_image, imageType, undefined, undefined, typeof banner?.bahasa_mobile_image === 'string' ? banner.bahasa_mobile_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "") : null);
          if (image8?.e) throw new Error(image8.e?.message);
          dataValues.bahasa_mobile_image = image8?.url;
        }
      } else {
        dataValues.bahasa_mobile_image = "";
      }

      let requiredFields = [];

      if (
        !dataValues.image &&
        !dataValues.traditional_chinese_image &&
        !dataValues.simplified_chinese_image &&
        !dataValues.bahasa_image
      ) {
        if (mediaOption === "video") {
          throw new Error("please upload the video");
        } else if (mediaOption === "link") {
          throw new Error("please add the link");
        } else {
          throw new Error("please upload the image");
        }
      }

      let valid = checkFields(dataValues, "banners", requiredFields);
      if (valid) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: valid,
        });
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });
      } else {
        try {
          setError();
          // Compute, from the whole group's current state, which old image
          // files this save will orphan — an old value held by any location
          // in the group that won't match the new value being applied
          // everywhere. Sent once to the backend after all the location
          // saves below finish, so it doesn't depend on their ordering.
          const BANNER_IMAGE_FIELDS = [
            "image", "english_mobile_image", "simplified_chinese_image", "traditional_chinese_image",
            "simplified_mobile_chinese_image", "traditional_mobile_chinese_image", "arabic_image",
            "bahasa_image", "bahasa_mobile_image",
          ];
          const oldImageValues = new Set();
          currentLocation.forEach((item) => {
            BANNER_IMAGE_FIELDS.forEach((field) => {
              if (item[field]) oldImageValues.add(item[field]);
            });
          });
          const imagesToDelete = Array.from(oldImageValues).filter(
            (file) => !BANNER_IMAGE_FIELDS.some((field) => dataValues[field] === file)
          );

          await Promise.all(
            currentLocation.map(async (item) => {
              if (!displayLocation.includes(item.location_id)) {
                await deleteBannerData(item.id);
              }
            })
          );
          await Promise.all(
            displayLocation.map(async (item, index) => {
              const locTimezone = locationOption.find(i => i.id == item)?.timezone || "Asia/Kuala_Lumpur";
              let values = {
                location_id: item,
                url: bannerUrlData[item],
                ...dataValues,
                valid_from: valid_from ? moment.tz(valid_from, locTimezone).utc().format("YYYY-MM-DDTHH:mm:ss") : valid_from,
                valid_to: valid_to ? moment.tz(valid_to, locTimezone).utc().format("YYYY-MM-DDTHH:mm:ss") : valid_to,
              };

              let data;
              if (banner?.id) {
                let locationValue = currentLocation.filter(
                  (data) => data.location_id === item
                );
                if (locationValue.length > 0) {
                  let { ...rest } = values;
                  if (item === banner.location_id) {
                    data = await updateBannerData(locationValue[0].id, values);
                  } else {
                    data = await updateBannerData(locationValue[0].id, rest);
                  }
                } else {
                  await createBanner({ ...values, recordIteration: index + 1 });
                }
              } else {
                values = {
                  ...values,
                  recordIteration: index + 1,
                };
                data = await createBanner(values);
              }

              if (data?.error) {
                throw new Error(data.error);
              } else {
                if (banner?.id) {
                  addlog(
                    "Banner Updated",
                    "Banner",
                    {
                      id: banner.id,
                      title: values.title || banner.title,
                      url: values.url || banner.url,
                      location_id: item,
                    },
                    userDetails.id
                  );
                } else {
                  addlog(
                    "Banner Created",
                    "Banner",
                    {
                      id: data.id,
                      title: data.title,
                      url: data.url,
                      location_id: item,
                    },
                    userDetails.id
                  );
                }
              }
            })
          );

          await cleanupBannerImages(imagesToDelete);

          dispatch({
            type: "SET_LOADING",
            loading: false,
          });
          if (!banner.id) {
            navigate("/website/cms/homepage/banner");
          } else {
            navigate("/website/cms/homepage/banner");
            dispatch({
              type: "SET_ERROR_MESSAGE",
              errMess: { message: "Values updated", type: "success" },
            });
          }
        } catch (error) {
          dispatch({
            type: "SET_LOADING",
            loading: false,
          });

          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.message || "Unknown error occurred",
          });
        }
      }
    } catch (error) {
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.message || "Unknown error occurred",
      });
    }
  };
  return (
    <div>
      <section className="content">
        {error && (
          <div className="d-flex justify-content-center align-items-center text-danger">
            <p>{error}</p>
          </div>
        )}

        <div className="container-fluid">
          <div className="card">
            <form className="input_form" onSubmit={addBanner}>
              <div className="card-body">
                <div className="row">
                  <div className="col-lg-12">
                    <LocationAndExpcept
                      displayLocation={displayLocation}
                      banner={banner}
                      locationOption={locationOption}
                      options={locationOption}
                      setDisplayLocation={setDisplayLocation}
                      handleDisplayLocationChange={handleDisplayLocationChange}
                    />

                    <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                      <div className="fieldrow">
                        <label className="f_label">Media Type</label>
                        <Select
                          required
                          style={{ width: "100%", height: "45px" }}
                          value={mediaOption}
                          onChange={(e) => {
                            setMediaOption(e.target.value);
                          }}
                        >
                          {["image", "video", "link"].map((item, index) => (
                            <MenuItem key={item} value={item}>
                              {item.split("")[0].toUpperCase() +
                                item.slice(1, item.length)}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    </div>
                  </div>
                  <UploadFileImageBanner2
                    className="col-lg-3"
                    image={
                      banner?.image
                        ? `${constants.MEDIAURL}/${banner?.image}`
                        : banner?.image
                    }
                    label={"English Banner " + mediaOption}
                    placeholder={"Upload Banner"}
                    selectedFile={selectedFile}
                    setSelectedFile={setSelectedFile}
                    mediaType={mediaOption}
                  />

                  <UploadFileImageBanner2
                    className="col-lg-3"
                    image={
                      banner?.simplified_chinese_image
                        ? `${constants.MEDIAURL}/${banner?.simplified_chinese_image}`
                        : banner?.simplified_chinese_image
                    }
                    label={"Simplified Chinese Banner " + mediaOption}
                    placeholder={"Upload Simplified Chinese Banner"}
                    selectedFile={simplified_chinese_image}
                    setSelectedFile={setSimplified_chinese_image}
                    mediaType={mediaOption}
                  />

                  <UploadFileImageBanner2
                    className="col-lg-3"
                    image={
                      banner?.traditional_chinese_image
                        ? `${constants.MEDIAURL}/${banner?.traditional_chinese_image}`
                        : banner?.traditional_chinese_image
                    }
                    label={"Traditional Chinese Banner " + mediaOption}
                    placeholder={"Upload Traditional Chinese Banner"}
                    selectedFile={traditional_chinese_image}
                    setSelectedFile={setTraditional_chinese_image}
                    mediaType={mediaOption}
                  />
                  <UploadFileImageBanner2
                    className="col-lg-3"
                    image={
                      banner?.bahasa_image
                        ? `${constants.MEDIAURL}/${banner?.bahasa_image}`
                        : banner?.bahasa_image
                    }
                    label={"Bahasa Banner " + mediaOption}
                    placeholder={"Upload Bahasa Banner"}
                    selectedFile={bahasa_image}
                    setSelectedFile={setBahasa_image}
                    mediaType={mediaOption}
                  />

                  {mediaOption === "image" && (
                    <>
                      <AltTextInput className="col-lg-3" label="English Banner Alt Text" field="image_alt" values={altText} setValues={setAltText} />
                      <AltTextInput className="col-lg-3" label="Simplified Chinese Banner Alt Text" field="simplified_chinese_image_alt" values={altText} setValues={setAltText} />
                      <AltTextInput className="col-lg-3" label="Traditional Chinese Banner Alt Text" field="traditional_chinese_image_alt" values={altText} setValues={setAltText} />
                      <AltTextInput className="col-lg-3" label="Bahasa Banner Alt Text" field="bahasa_image_alt" values={altText} setValues={setAltText} />
                    </>
                  )}

                  {/* mobile banner */}
                  <UploadFileImageBanner2
                    className="col-lg-3"
                    image={
                      banner?.english_mobile_image
                        ? `${constants.MEDIAURL}/${banner?.english_mobile_image}`
                        : banner?.english_mobile_image
                    }
                    label={"English Mobile Banner " + mediaOption}
                    placeholder={"Upload Mobile Banner"}
                    width={"1280"}
                    height={"1024"}
                    selectedFile={english_mobile_image}
                    setSelectedFile={setEnglish_mobile_image}
                    mediaType={mediaOption}
                  />

                  <UploadFileImageBanner2
                    className="col-lg-3"
                    image={
                      banner?.simplified_mobile_chinese_image
                        ? `${constants.MEDIAURL}/${banner?.simplified_mobile_chinese_image}`
                        : banner?.simplified_mobile_chinese_image
                    }
                    label={"Simplified Chinese Mobile Banner " + mediaOption}
                    placeholder={"Upload Simplified Chinese Mobile Banner"}
                    width={"1280"}
                    height={"1024"}
                    selectedFile={simplified_mobile_chinese_image}
                    setSelectedFile={setSimplified_mobile_chinese_image}
                    mediaType={mediaOption}
                  />

                  <UploadFileImageBanner2
                    className="col-lg-3"
                    image={
                      banner?.traditional_mobile_chinese_image
                        ? `${constants.MEDIAURL}/${banner?.traditional_mobile_chinese_image}`
                        : banner?.traditional_mobile_chinese_image
                    }
                    label={"Traditional Chinese Mobile Banner " + mediaOption}
                    placeholder={"Upload Traditional Chinese Mobile Banner"}
                    width={"1280"}
                    height={"1024"}
                    selectedFile={traditional_mobile_chinese_image}
                    setSelectedFile={setTraditional_mobile_chinese_image}
                    mediaType={mediaOption}
                  />

                  <UploadFileImageBanner2
                    className="col-lg-3"
                    image={
                      banner?.bahasa_mobile_image
                        ? `${constants.MEDIAURL}/${banner?.bahasa_mobile_image}`
                        : banner?.bahasa_mobile_image
                    }
                    label={"Bahasa Mobile Banner " + mediaOption}
                    placeholder={"Upload Bahasa Mobile Banner"}
                    width={"1280"}
                    height={"1024"}
                    selectedFile={bahasa_mobile_image}
                    setSelectedFile={setBahasa_mobile_image}
                    mediaType={mediaOption}
                  />
                  {mediaOption === "image" && (
                    <>
                      <AltTextInput className="col-lg-3" label="English Mobile Banner Alt Text" field="english_mobile_image_alt" values={altText} setValues={setAltText} />
                      <AltTextInput className="col-lg-3" label="Simplified Chinese Mobile Banner Alt Text" field="simplified_mobile_chinese_image_alt" values={altText} setValues={setAltText} />
                      <AltTextInput className="col-lg-3" label="Traditional Chinese Mobile Banner Alt Text" field="traditional_mobile_chinese_image_alt" values={altText} setValues={setAltText} />
                      <AltTextInput className="col-lg-3" label="Bahasa Mobile Banner Alt Text" field="bahasa_mobile_image_alt" values={altText} setValues={setAltText} />
                    </>
                  )}

                  <div className="col-lg-8 col-md-6 col-sm-6 col-6">
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                        <div className="fieldrow">
                          <label className="f_label">
                            {" "}
                            Valid From <span style={{ color: "red" }}>*</span>
                          </label>
                          <DateAndTimePicker
                            value={valid_from}
                            min={moment(new Date()).format("YYYY-MM-DD")}
                            setValue={(e) => {
                              const val = e ? (e?.format ? e.format("YYYY-MM-DDTHH:mm:ss") : e) : "";
                              setValidFrom(val);
                              setValidTo("");
                              setIsDateEdit(
                                val !== originalValidDates.current.valid_from ||
                                "" !== originalValidDates.current.valid_to
                              );
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                        <div className="fieldrow">
                          <label className="f_label">
                            Valid To <span style={{ color: "red" }}>*</span>
                          </label>
                          <DateAndTimePicker
                            value={valid_to}
                            min={valid_from ? moment(valid_from).format("YYYY-MM-DD") : moment(new Date()).format("YYYY-MM-DD")}
                            disabled={!valid_from}
                            setValue={(e) => {
                              const val = e ? (e?.format ? e.format("YYYY-MM-DDTHH:mm:ss") : e) : "";
                              setValidTo(val);
                              setIsDateEdit(
                                valid_from !== originalValidDates.current.valid_from ||
                                val !== originalValidDates.current.valid_to
                              );
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    {displayLocation.length > 0 && (
                      <p style={{ marginTop: "8px", fontSize: "13px", color: "#666" }}>
                        {displayLocation.length === 1
                          ? `* Dates will be saved in ${locationOption.find(i => i.id == displayLocation[0])?.location_name} timezone (${locationOption.find(i => i.id == displayLocation[0])?.timezone}). Your timezone is ${getMyZone()}`
                          : `* Dates will be saved in each location's own timezone and converted to UTC. Your timezone is ${getMyZone()}`}
                      </p>
                    )}
                  </div>

                  <div className="w-100"></div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">English Title</label>
                      <ReactQuill
                        value={englishTitle}
                        onChange={handleEnglishTitleChange}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">
                        Simplified Chinese Title
                      </label>
                      <ReactQuill
                        value={simplifiedChineseTitle}
                        onChange={handleSimplifiedChineseTitleChange}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">
                        Traditional Chinese Title
                      </label>
                      <ReactQuill
                        value={traditionalChineseTitle}
                        onChange={handleTraditionalChineseTitleChange}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="fieldrow">
                      <label className="f_label">Bahasa Title</label>
                      <ReactQuill
                        value={bahasa_title}
                        onChange={handleBahasaTitleChange}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>

                  {displayLocation.map((item) => (
                    <div
                      key={item}
                      className="col-lg-4 col-md-12 col-sm-12 col-12"
                    >
                      <div className="fieldrow">
                        <label className="f_label">
                          Url{" "}
                          {
                            locationOption.find((l) => item === l.id)
                              ?.location_name
                          }
                        </label>
                        <input
                          className="f_input"
                          type="text"
                          value={bannerUrlData?.[item]}
                          onChange={(e) =>
                            setBannerUrlData((data) => ({
                              ...data,
                              [item]: e.target.value,
                            }))
                          }
                        />
                      </div>
                    </div>
                  ))}
                  <div className="col-12">
                    <div className="iti_inner">
                      <div className="icheck-primary d-inline">
                        <input
                          type="checkbox"
                          id="customCheckbox4"
                          name="r10"
                          checked={isActive}
                          onChange={handleCheckboxChange}
                        />
                        <label htmlFor="customCheckbox4">
                          {isActive ? (
                            <p>
                              <span style={{ fontWeight: 600 }}>Active</span>
                            </p>
                          ) : (
                            <p>
                              <span style={{ fontWeight: 200 }}>Active</span>
                            </p>
                          )}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer text-right">
                <button className="btn main_submit">
                  {banner.id ? "Update" : "Add"} Banner
                </button>
              </div>
            </form>
          </div>
          <div className="pt-3"></div>
        </div>
      </section>
    </div>
  );
};
BannerInputs.propTypes = {
  banner: PropTypes.any,
};
export default BannerInputs;
